<template>
  <div>
    <van-tabbar v-model="active" fixed :route="true">
      <van-tabbar-item to="/home"><van-icon class-prefix="fa fa" name="bars" size="1.2rem" /><p>主控面板</p></van-tabbar-item>
      <van-tabbar-item to="/user"><van-icon class-prefix="fa fa" name="user-o" size="1.2rem" /><p>用户中心</p></van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      active: 0
    }
  },
  methods: {
  },
  mounted () {
    // we can implement any method here like
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p{
  margin: 0;
  padding: 8px;
  font-size: 0.8rem;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/card/views/Bottom.vue